export const SET_HOME_SLIDE = 'content/slide'
export const SET_HOME_SERVICE = 'content/service'
export const SET_HOME_CLIENT = 'content/client'
export const SET_HOME_PRODUCT = 'content/product'
export const SET_HOME_NEWS = 'content/news'
export const SET_BUSINESS_UNIT = 'content/businessUnit'
export const SET_ABOUT_US_SLIDE = 'content/aboutUsSlide'
export const SET_BUSINESS_UNIT_SLIDE = 'content/businessUnitSlide'
export const SET_CAREER_SLIDE = 'content/careerSlide'
